angular.module('impactx.login').controller('SCustomLoginCtrl', [
    '$scope',
    'LoginService',
    '$routeParams',
    'cookieService',
    '$redirect',
    'BrowserSettings',
    'AppConfiguration',
    'LegalLinking',
    '$config',
    '$mdDialog',
    '$context',
    '$workspace',
    'TranslationService',
    SCustomLoginCtrl
]);

function SCustomLoginCtrl($scope, LoginService, $routeParams, cookieService, $redirect, BrowserSettings, AppConfiguration, LegalLinking, $config, $mdDialog, $context, $workspace, TranslationService) {
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.loginAllowed = BrowserSettings.cookiesEnabled;
    $scope.translations = TranslationService;

    LoginService.getCustomLoginData($routeParams.value).then(function(data) {
        if(isEmpty(data)) {
            $redirect.redirectTo(null, $config.loginRoute);
        }
        else {
            $scope.data = data;
            $context.comIdForThemes.value = $scope.data.clientComIdForThemes;
            $workspace.activateWorkspace('shop');
            cookieService.setCookie("loginPage", $routeParams.value);
            LoginService.prepareLogin(dialogFunction);
        }
    });

    var isEmpty = function isEmpty(ob) {
        for (var i in ob) {
            if (ob.hasOwnProperty(i)) {
                return false;
            }
        }
        return true;
    };

    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };

    function dialogFunction() {
        $mdDialog.show({
            multiple: true,
            templateUrl: 'modules/login/templates/s-login.tmpl.html',
            controller: 'LoginDialogController',
            controllerAs: "loginCtrl",
            bindToController: true,
            locals: {
                customLogoURL: $scope.data.logo,
                customHash: $routeParams.value,
                customLoginTranslations: $scope.data.loginTranslations
            },
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false,
            onComplete: function (scope) {
                scope.dialogData.password.$setValidity("cookiesDisabled", BrowserSettings.cookiesEnabled);
                scope.isLoaded = true;
            }
        });
    }
}